import { Component, OnInit } from '@angular/core';
import { appRevision, appVersion } from '../../../../../environments/version';

@Component({
  selector:    'app-footer',
  templateUrl: './footer.component.html',
  styleUrls:   [ './footer.component.scss' ]
})
export class FooterComponent implements OnInit {

  now: string;

  rev: string;

  constructor() {
  }

  ngOnInit() {
    this.now = new Date().getFullYear().toString();

    this.rev = `${appVersion}+${appRevision.substr(0, 6)}`;
  }

}



// WEBPACK FOOTER //
// C:/projektyWeb/McComp_Flota/Front/src/app/pages/shared/footer/footer/footer.component.ts